/* IMPORT */
import adjustChannel from './adjust_channel.js';
/* MAIN */
const opacify = (color, amount) => {
    return adjustChannel(color, 'a', amount);
};
/* EXPORT */
export default opacify;
